import { render, staticRenderFns } from "./EmailDetails.vue?vue&type=template&id=370bc662&scoped=true"
import script from "./EmailDetails.vue?vue&type=script&lang=ts"
export * from "./EmailDetails.vue?vue&type=script&lang=ts"
import style0 from "./EmailDetails.vue?vue&type=style&index=0&id=370bc662&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370bc662",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('370bc662')) {
      api.createRecord('370bc662', component.options)
    } else {
      api.reload('370bc662', component.options)
    }
    module.hot.accept("./EmailDetails.vue?vue&type=template&id=370bc662&scoped=true", function () {
      api.rerender('370bc662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/components/EmailDetails.vue"
export default component.exports